import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Button
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import TableContainer from '../../../components/Common/TableContainer';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchHolidayEmployee, fetchHolidayProcessListRequest, fetchHolidays, saveHolidayProcess } from "store/actions";
import CustomSelect from "components/Common/custom-select";
import { FiRepeat, FiSave } from "react-icons/fi";
import { convertToInputDate } from "common/dateFormat/formatDate";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const HolidayProcess = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    categories,
    departments,
    designations,
    dropdownAutoList,
    holidays,
    holidayProcess,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories,
    departments: state.DepartmentMaster?.departments,
    designations: state.DesignationMaster?.designations,
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList,
    holidays: state.holidayReducer?.holidays,
    holidayProcess: state.holidayReducer?.holidayProcess,

    loading: state.holidayReducer?.loading || state.CategoryMaster?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.holidayReducer?.error || state.CategoryMaster?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error || state.EmployeeDetailsReducer?.error,
    success: state.holidayReducer?.success
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId));
    dispatch(fetchHolidays(unitId));
    dispatch(fetchHolidayProcessListRequest(unitId));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(fetchHolidays(authDetails?.unit_id));
      formik.resetForm()
    }
  }, [authDetails, success, dispatch]);

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      employee: "",
      holidays: "",
    },
    validationSchema: Yup.object({
      // category: Yup.array().required("Category is required"),
      // department: Yup.array().required("Department is required"),
      // designation: Yup.array().required("Designation is required"),
      // employee: Yup.array().required("Employee is required"),

      holidays: Yup.array().required("Holidays is required"),
    }),
    onSubmit: (values) => {
      // console.log('values > ', values);
      const formData = new FormData();
      formData.append(
        "cat_ids",
        values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "dept_ids",
        values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "desig_ids",
        values.designation && values.designation.length ? values.designation.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "emp_ids",
        values.employee && values.employee.length ? values.employee.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "holiday_date",
        values.holidays && values.holidays.length ? values.holidays.map(item => item.date).join(",") : '0'
      );

      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(saveHolidayProcess(formData));
    },
  });

  const columns = useMemo(() => [
    {
      Header: "SNo",
      Cell: ({ row }) => holidayProcess.length - row.index,
      className: "serial-no",
      applyHeaderClass: true,
    },
    { Header: "Processed On", accessor: "last_run_dt" },
    { Header: "Dates", accessor: "dates" },
    { Header: "Category", accessor: "category" },
    { Header: "Department", accessor: "department" },
    { Header: "Designation", accessor: "designation" },
    { Header: "Employees", accessor: "employees" },
    { Header: "By", accessor: "ProcessedBy" },
  ], [holidayProcess]);

  const handleCancel = () => {
    formik.resetForm();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <Container fluid className="mt-4">
          <Breadcrumbs title="Holiday" breadcrumbItem="Holiday Process" />
          {canCreate && (
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col md={4} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="category">Category</Label>
                      <CustomSelect
                        id="category"
                        name="category"
                        options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                        value={formik.values.category || null}
                        onChange={(selectedOption) => formik.setFieldValue("category", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.category && formik.errors.category && (
                        <div className="text-danger">{formik.errors.category}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={4} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="department">Department</Label>
                      <CustomSelect
                        id="department"
                        name="department"
                        options={departments.map(cat => ({ value: cat.departmentId.toString(), label: cat.departmentname }))}
                        value={formik.values.department || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.department && formik.errors.department && (
                        <div className="text-danger">{formik.errors.department}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={4} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="designation">Designation</Label>
                      <CustomSelect
                        id="designation"
                        name="designation"
                        options={designations.map(cat => ({ value: cat.desig_id.toString(), label: cat.designation }))}
                        value={formik.values.designation || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("designation", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.designation && formik.errors.designation && (
                        <div className="text-danger">{formik.errors.designation}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Employee Selection */}
                  <Col md={4} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="employee">Employee</Label>
                      <CustomSelect
                        id="employee"
                        name="employee"
                        options={dropdownAutoList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                        value={formik.values.employee || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">{formik.errors.employee}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={4} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="holidays">Holiday <span className="text-danger">*</span></Label>
                      <CustomSelect
                        id="holidays"
                        name="holidays"
                        options={holidays.map(cat => ({ value: cat.HolidayID.toString(), label: `${cat.Description}  -  ${cat.Date}`, date: convertToInputDate(cat.Date) }))}
                        value={formik.values.holidays || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("holidays", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.holidays && formik.errors.holidays ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.holidays && formik.errors.holidays && (
                        <div className="text-danger">{formik.errors.holidays}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Buttons */}
                  <Col md={4} sm={12} className="d-flex align-items-center justify-content-end">
                    <Button type="submit" className="btn button-save me-2">
                      <i className="fas fa-spinner me-1" />Process
                    </Button> 
                    {/* <Button type="button" color="primary" className="me-2">
                      <FiSave/>Submit
                    </Button> */}
                    <Button type="button" color="secondary" onClick={handleCancel} className="btn button-cancel">
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
          )}

          <Card className="mt-4">
            <CardBody>
              <TableContainer
                columns={columns}
                data={holidayProcess && holidayProcess.length > 0 ? holidayProcess : []}
                isGlobalFilter={true}
                customPageSize={10}
                className="custom-header-css"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default HolidayProcess;
